import { CustomControlModel } from '@shared/models/devices/CustomControlModel';
import { UserDeviceCustomControlModel } from '@shared/models/devices/UserDeviceCustomControlModel';
import UserDeviceCustomControlOverrideModel from '@shared/models/devices/UserDeviceCustomControlOverrideModel';

export const isLicensedCustomControl = (customControl: CustomControlModel): boolean => {
    return (
        customControl.requiresEmployeeAccess ||
        customControl.requiresGenericLicense ||
        customControl.requiresPlusAccess ||
        customControl.requiresStudentAccess
    );
};

export const getCustomControlModels = (
    deviceControls: UserDeviceCustomControlModel[],
    controlOverrides: UserDeviceCustomControlOverrideModel[]
): CustomControlModel[] => {
    const result: CustomControlModel[] = [];
    const controlIds: Set<string> = new Set();

    for (const control of deviceControls) {
        result.push({ ...control, commands: control.defaultCommands ?? [] });
        controlIds.add(control.id);
    }

    // take override over the defaults if available
    for (const override of controlOverrides) {
        if (controlIds.has(override.deviceTypeCustomControlId)) {
            const control = result.find((c) => c.id === override.deviceTypeCustomControlId);
            if (control && (override.commands?.length ?? 0) > 0) {
                control.commands = override.commands;
            }

            // todo: hotkey
        }
    }

    return result;
};
